import { Carousel } from '@mantine/carousel'
import { Box } from '@mantine/core'

import useHorizontalOverflow from '@/components/Swiper/useHorizontalOverflow'
import { useIsResponsiveMobileView } from '@/hooks/responsive'

interface CarouselSlidesProps<T> {
  swiperList: T[]
  renderSwiper: (item: T, index: number) => React.ReactNode
  onSlideChange: (index: number) => void
  getEmblaApi: (embla: any) => void
  slideGap?: string | number
  includeGapInSize?: boolean
}

export default function CarouselSlides<T>({
  swiperList,
  renderSwiper,
  onSlideChange,
  getEmblaApi,
  slideGap,
  includeGapInSize,
}: CarouselSlidesProps<T>) {
  const { containerRef, hasOverflow } = useHorizontalOverflow([swiperList])
  const isMobile = useIsResponsiveMobileView()
  const defaultSlideGap = slideGap ?? (isMobile ? 16 : 24)
  const resolvedGap =
    typeof defaultSlideGap === 'number' ? `${defaultSlideGap}px` : (defaultSlideGap ?? '24px')
  const resolvedSlideSize = includeGapInSize ? `calc(100% + ${resolvedGap})` : 'auto'

  return (
    <Box pos="relative" ref={containerRef}>
      <Carousel
        withControls={false}
        onSlideChange={onSlideChange}
        getEmblaApi={getEmblaApi}
        slideSize={resolvedSlideSize}
        slideGap={resolvedGap}
        // withIndicators
        emblaOptions={{
          loop: false,
          dragFree: false,
          align: 'start',
        }}
      >
        {swiperList.map((item, i) => (
          <Carousel.Slide key={i}>{renderSwiper(item, i)}</Carousel.Slide>
        ))}
      </Carousel>
      {/* right shadow */}
      {hasOverflow && (
        <Box
          className="shadow-right"
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: 40,
            height: '100%',
            pointerEvents: 'none',
            background: 'linear-gradient(to left, #101522 0%, rgba(16,21,34,0) 100%)',
          }}
        />
      )}
    </Box>
  )
}
